import {
    Cost,
    Entity,
} from '@backstage/plugin-cost-insights-common';

import {
    ApiClientOptions,
} from '../types';

import { ProxyApiClient } from '../../ProxyApiClient';

export interface KubecostApiResponseBucket<T = any> {
    [key: string]: T;
}

export interface KubecostApiResponse<T = any> {
    code: number;
    data: KubecostApiResponseBucket<T>[];
}

export class KubecostClient extends ProxyApiClient {
    constructor(opts: ApiClientOptions) {
        super({
            discoveryApi: opts.discoveryApi,
            identityApi: opts.identityApi,
            pluginName: 'kubecost',
            proxyPath: '/',
        });
    }

    async fetchKubecostApi<T = (Cost | Entity)>(path: string, params: any): Promise<T> {
        const queryParams = new URLSearchParams();

        let k: keyof typeof params;
        for (k in params) {
            const val = params[k];

            if (val) {
                queryParams.append(k, val + '');
            }
        }

        const response = await this.fetch<T>(
            `${path}?${queryParams}`,
        );

        return response;
    }

    async fetchLastCompleteBillingDate(): Promise<string> {
        const { lastUpdatedAt } = await this.fetch<{lastUpdatedAt: string}>('last-complete-billing-date');
        return lastUpdatedAt;
    }

    async fetchDailyCostGroupReport(group: string, intervals: string): Promise<Cost> {
        return this.fetchKubecostApi<Cost>('report/daily-cost/group', {
            group,
            intervals,
        });
    }

    async fetchDailyCostProjectReport(project: string, intervals: string): Promise<Cost> {
        return this.fetchKubecostApi<Cost>('report/daily-cost/project', {
            project,
            intervals,
        });
    }

    async fetchProductInsightsReport(product: string, group: string, project: string | null, intervals: string): Promise<Entity> {
        return this.fetchKubecostApi<Entity>('report/product-insights', {
            product,
            group,
            project,
            intervals,
        });
    }

}
